<template>
  <div class="module-card" :class="moduleData.colorClass" @click="navigateToModule">
    <div class="card-icon">
      <b-icon :icon="moduleData.icon"></b-icon>
    </div>
    <div class="card-content">
      <h3 class="card-title">{{ moduleData.title }}</h3>
      <p class="card-description">{{ moduleData.description }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModuleCard',
  props: {
    moduleData: {
      type: Object,
      required: true
    }
  },
  methods: {
    navigateToModule() {
      this.$router.push(this.moduleData.route)
    }
  }
}
</script>

<style scoped>
.module-card {
  border-radius: 15px;
  padding: 1rem;
  transition: all 0.3s ease;
  cursor: pointer;
  height: 100%;
}

.module-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0,0,0,0.1);
}

.card-icon {
  font-size: 2rem;
  margin-bottom: 0.8rem;
}

.card-title {
  font-size: 1.2rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.card-description {
  font-size: 1rem;
  opacity: 0.8;
}

.bg-primary-soft {
  background-color: #e8f0fe;
  color: #1967d2;
}

.bg-success-soft {
  background-color: #e6f4ea;
  color: #1e8e3e;
}

.bg-warning-soft {
  background-color: #fef7e0;
  color: #f9ab00;
}

.bg-danger-soft {
  background-color: #fce8e6;
  color: #d93025;
}

.bg-info-soft {
  background-color: #e8f0fe;
  color: #1a73e8;
}

.bg-purple-soft {
  background-color: #f3e8fd;
  color: #9334e6;
}
</style>